import {InjectedHomeSectionGroup} from '#/components/home-content/injected-home-section-group';
import {useInjectedHomeSections} from '#/hooks/query/use-injected-home-sections';
import {FunctionComponent} from 'react';
import {useTranslation} from 'react-i18next';

export const InjectedHomeSections: FunctionComponent = () => {
  const {t} = useTranslation('translation');
  const {data: {premium, discounted, rentalYield} = {}} = useInjectedHomeSections();

  return (
    <>
      {premium && premium.active && (
        <InjectedHomeSectionGroup
          title={t('pages.home.injectedSections.premium.title')}
          subtitle={t('pages.home.injectedSections.premium.subtitle')}
          homeSection={premium}
        />
      )}
      {discounted && discounted.active && (
        <InjectedHomeSectionGroup
          title={t('pages.home.injectedSections.discounted.title')}
          subtitle={t('pages.home.injectedSections.discounted.subtitle')}
          homeSection={discounted}
        />
      )}
      {rentalYield && rentalYield.active && (
        <InjectedHomeSectionGroup
          title={t('pages.home.injectedSections.rentalYield.title', {
            numberOfLocations: rentalYield.landTokenSymbols.length,
          })}
          subtitle={t('pages.home.injectedSections.rentalYield.subtitle')}
          homeSection={rentalYield}
        />
      )}
    </>
  );
};
